
import { faApple, faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons'
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'GuardAuth',

  data() {
    return {
      formModel: { ...this.$store.state.auth.loginApi.model },
      errorMessage: null,
      faQuestionCircle,
      faGoogle,
      faFacebook,
      faApple
    }
  },

  created() {
    if (this.$app.isAuth) {
      this.$emit('authenticated')
    }
  },

  mounted() {
    if (this.$biometrics.isActive()) {
      this.loginWithBiometrics()
    }
  },

  methods: {
    async sendAuth(skipBiometrics = false) {
      this.errorMessage = null

      try {
        await this.$store.dispatch('auth/login', this.formModel)

        if (this.$app.isAuth) {
          if (this.$biometrics.isAvailable) {
            if (!skipBiometrics) {
              const isAuthenticated = await this.$biometrics.isAuthenticated()

              if (isAuthenticated) {
                await this.$biometrics.saveCredentials(this.formModel.email, this.formModel.password)
              }
            } else {
              await this.$biometrics.saveCredentials(this.formModel.email, this.formModel.password)
            }
          }

          this.$emit('authenticated')
        }
      } catch (error) {
        this.$log.warn('Error logging in', error)
      }
    },

    async loginWithBiometrics() {
      if (this.$app.isAuth || !this.$biometrics || !this.$biometrics.isAvailable) {
        return false
      }

      try {
        const isAuthenticated = await this.$biometrics.isAuthenticated()

        if (isAuthenticated) {
          const { email, password } = await this.$biometrics.getCredentials()

          this.formModel.email = email
          this.formModel.password = password

          this.sendAuth(true)
        }
      } catch (error) {
        this.$log.error('Error logging in with biometrics', error)
        this.$notify.error(this.$t('errorLoggingInWithBiometrics'))
      }
    },

    async loginWithApple() {
      const APPLE_COOKIE_KEY = 'seen-sign-in-warning'

      if (!this.$cookies.get(APPLE_COOKIE_KEY)) {
        const confirmed = await this.$confirm({
          title: 'Sign in with Apple account linking',
          description:
            'Please note if you "hide" your email with Apple sign in we will not be able to link previous bookings made with your real email address',
          confirmButtonLabel: 'Continue to sign in with Apple'
        })

        if (!confirmed) {
          return false
        }

        this.$cookies.set('apple-sign-in-warning', true, {
          expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 10),
          path: '/'
        })

        this.$cookies.set(APPLE_COOKIE_KEY, true, {
          expires: this.$date().add(365, 'day').toDate(),
          path: '/'
        })
      }

      await this.$store.dispatch('auth/loginSocial', { provider: 'apple' })
    },

    setAuthEmail() {
      this.$store.commit('setGlobalState', {
        statePath: 'auth.loginApi.model',
        newState: this.formModel
      })
    }
  }
}
